export enum predefinedFiltersId {
  potentiallyUntranslated = 1
}

export enum queryFilters {
  text = 'search_in_text',
  originalText = 'search_in_original_text'
}

export enum filterId {
  query = 'query',
  textId = 'id',
  language = 'language',
  textCollection = 'textCollection',
  textSet = 'textSet',
  potentiallyUntranslatedOnly = 'potentiallyUntranslatedOnly'
}

export enum fieldType {
  root = 'root'
}

export const excelExportFilename = 'export-translation-list';
